import { render, staticRenderFns } from "./DetailConfigDatasetField.vue?vue&type=template&id=3ed48608"
import script from "./DetailConfigDatasetField.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports